(function () {
  function initStickyATC() {
    // Dawn puts the submit button outside <form>, find it directly
    var submitBtn = document.querySelector('button[name="add"].product-form__submit') ||
                    document.querySelector('button[name="add"]');
    if (!submitBtn) return;

    var productTitle = document.querySelector('.product__title, h1.title');
    var productPrice = document.querySelector('.price__regular .price-item, .price .price-item--regular, .price__sale .price-item');
    var productImg = document.querySelector('.product__media--active img, .product__media img, .product-media-container img');

    var bar = document.createElement('div');
    bar.className = 'sticky-atc';
    bar.innerHTML = [
      '<div class="sticky-atc__inner">',
        productImg ? '<img class="sticky-atc__img" src="' + (productImg.currentSrc || productImg.src) + '" alt="">' : '',
        '<div class="sticky-atc__info">',
          '<div class="sticky-atc__title">' + (productTitle ? productTitle.innerText.trim() : '') + '</div>',
          '<div class="sticky-atc__price">' + (productPrice ? productPrice.innerText.trim() : '') + '</div>',
        '</div>',
        '<button class="sticky-atc__btn" type="button">' + (submitBtn.textContent.trim() || 'Add to cart') + '</button>',
      '</div>'
    ].join('');

    document.body.appendChild(bar);

    var stickyBtn = bar.querySelector('.sticky-atc__btn');

    stickyBtn.addEventListener('click', function () {
      submitBtn.click();
    });

    // Keep sticky button state in sync
    var mutObs = new MutationObserver(function () {
      stickyBtn.disabled = submitBtn.disabled;
      var newText = submitBtn.textContent.trim();
      if (newText) stickyBtn.textContent = newText;
    });
    mutObs.observe(submitBtn, { attributes: true, childList: true, subtree: true, characterData: true });

    function onScroll() {
      var btnBottom = submitBtn.getBoundingClientRect().bottom;
      if (btnBottom < 0) {
        bar.classList.add('sticky-atc--visible');
      } else {
        bar.classList.remove('sticky-atc--visible');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }
})();
